export const DATE_FORMAT = {
    identity: {
        birthDate: {
            FR: "DD/MM/YYYY",
            BE: "DD/MM/YYYY",
            IT: "DD/MM/YYYY",
            ES: "DD/MM/YYYY",
            PT: "DD/MM/YYYY",
            NL: "DD/MM/YYYY",
        },
        identificationExpirationDate: {
            FR: "DD/MM/YYYY",
            BE: "DD/MM/YYYY",
            IT: "DD/MM/YYYY",
            ES: "DD/MM/YYYY",
            PT: "DD/MM/YYYY",
            NL: "DD/MM/YYYY",
        }
    },
    coordinates: {
        yearBankSeniority: {
            FR: "YYYY",
            BE: "YYYY",
            ES: "YYYY",
            PT: "YYYY",
            NL: "YYYY",
        },
    },
    identityDocuments: {
        documentDateOfIssue: {
            IT: "DD/MM/YYYY",
            ES: "DD/MM/YYYY",
        },
        residencePermitExpiryDate: {
            IT: "MM/YYYY",
        }
    },
    situation: {
        employmentDate: {
            FR: "YYYY",
            BE: "YYYY",
            IT: "MM/YYYY",
            ES: "MM/YYYY",
            PT: "MM/YYYY",
            NL: "YYYY",
        },
        residenceDate: {
            FR: "YYYY",
            BE: "YYYY",
            IT: "YYYY",
            ES: "YYYY",
            PT: "YYYY",
            NL: "YYYY",
        },
        endContractDate: {
            IT: "MM/YYYY",
        },
        yearBankSeniority: {
            IT: "YYYY",
            ES: "YYYY",
            PT: "YYYY",
            BE: "YYYY",
            NL: "YYYY",
        },
    }
}

export const FOREIGN_DEPARTEMENT = 'EE'; 